export default {
  IFRAME_ID: 'fpuiStore',
  API: (process.env.API_URL || ''),
}
